import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
const MyButton = styled(Button)(({
  theme,
  color
}) => `
  background-color: ${color ? color : theme.palette.primary.light};

  & svg {
    fill: ${color ? color : theme.palette.primary.main};
  }

  :hover {
    background-color: ${color ? color : theme.palette.primary.main};

    & svg {
      fill: ${color ? color : theme.palette.primary.light};
    }

  }
`);
export default MyButton;